import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-muted/30">
      <Navbar />
      
      <div className="max-w-2xl mx-auto px-4 py-20" data-testid="payment-cancel-page">
        <Card className="p-8 md:p-12 rounded-2xl text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-12 w-12 text-red-600" />
          </div>
          <h1 className="font-heading text-3xl font-bold text-foreground mb-3">
            Payment Cancelled
          </h1>
          <p className="text-muted-foreground mb-8 max-w-md mx-auto">
            Your payment was cancelled. Don't worry, no charges were made. 
            You can try again or explore other tours.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/bookings">
              <Button variant="outline" className="rounded-full px-8" data-testid="view-bookings-btn">
                <ArrowLeft className="h-4 w-4 mr-2" />
                View My Bookings
              </Button>
            </Link>
            <Link to="/tours">
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8" data-testid="try-again-btn">
                <RefreshCw className="h-4 w-4 mr-2" />
                Browse Tours
              </Button>
            </Link>
          </div>
        </Card>
      </div>

      <Footer />
    </div>
  );
}
